import React, { FC, useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { OverlayDummyContent } from 'src/components/common/Overlay/OverlayDummyContent';
import { commonSelector } from 'src/store/commonPart/selector';
import { createArrayXLength } from 'src/utils/objects';

export const CampaignOverlayDummyContent: FC = () => {
  const { screenWidth } = useSelector(commonSelector);

  const getDummyItemsAmount = useCallback((screenWidth: number): number[] => {
    let dummyItemsCount = 3;

    if (screenWidth >= 1200) {
      dummyItemsCount = 4;
    } else if (screenWidth < 963) {
      dummyItemsCount = 2;
    }
    return createArrayXLength(dummyItemsCount).map((_, i) => i);
  }, []);

  const dummyItemsAmount = useMemo(() => getDummyItemsAmount(screenWidth), [getDummyItemsAmount, screenWidth]);

  return (
    <OverlayDummyContent>
      <div className="campaign-management-overlay-banner">
        <div className="banner">
          <div className="media" />
          <div className="block1" />
          <div className="block2" />
          <div className="block3" />
          <div className="block4" />
          <div className="block4" />
          <div className="block4" />
          <div className="block5">
            <div className="circle" />
            <div className="circle" />
            <div className="circle" />
            <div className="circle" />
          </div>
        </div>
      </div>
      <div className="campaign-management-overlay-scrolling-container2">
        <div className="campaign-management-overlay-scrolling-content">
          <div id="overlay-quick-actions-menu-container" className="quick-menu-expanded">
            <div className="quick-actions-menu-content">
              <div className="quick-actions-menu-content-positioner">
                <div className="quick-actions-menu-dummy-actions">
                  <div className="quick-actions-menu-organizer-actions">
                    <div className="quick-actions-menu-organizer-actions-header">
                      <div className="quick-actions-menu-actions-title" />
                    </div>

                    <div className="quick-actions-menu-organizer-actions-container">
                      {dummyItemsAmount.map((k) => (
                        <div className="quick-menu-item-container" key={k}>
                          <div className="quick-menu-item-sub-container quick-menu-item-dummy-sub-container" />
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="quick-actions-menu-organizer-actions">
                    <div className="quick-actions-menu-organizer-actions-header">
                      <div className="quick-actions-menu-actions-title" />
                    </div>

                    <div className="quick-actions-menu-organizer-actions-container">
                      {dummyItemsAmount.map((k) => (
                        <div className="quick-menu-item-container" key={k}>
                          <div className="quick-menu-item-sub-container quick-menu-item-dummy-sub-container" />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </OverlayDummyContent>
  );
};
